import PropTypes from "prop-types";
import React from "react";
import "./style.scss";
import AttachmentIcon from "../Processes/conversations/AttachmentIcon";

const fileIcons = {
  "application/pdf": "PDF",
  "text/csv": "CSV",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "DOCX",
  "application/msword": "DOC",
  "image/jpg": "JPG",
  "image/jpeg": "JPGE",
  "image/png": "PNG",
  "text/plain": "TXT",
  "application/vnd.ms-excel": "XLSX",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLS",
  "application/zip": "ZIP",
};

const FileIcon = ({
  filetype,
  filename,
  downloadFile = () => {},
  className = "",
  isPayslipFolder = false,
  ...rest
}) => {
  const iconAlt = !isPayslipFolder && (fileIcons[filetype] || fileIcons["doc"]);

  return (
    <div className={`file__icon ${className}`.trim()} {...rest}>
      <AttachmentIcon file={{ type: filetype }} />

      {filename && (
        <span
          className="file__icon__name cursor-pointer"
          onClick={downloadFile}
        >
          {filename} {!isPayslipFolder && `(${iconAlt})`}
        </span>
      )}
    </div>
  );
};

FileIcon.propTypes = {
  filetype: PropTypes.string,
  filename: PropTypes.string,
  className: PropTypes.string,
  isPayslipFolder: PropTypes.bool,
};

export default FileIcon;
